import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Link } from 'react-router-dom';


const ProductGroup = () => {
  const [modal_list, setModal_list] = useState(false);

  const tog_list = () => {
    setModal_list(!modal_list);
  };

 
    const productgroup = [
        { id: "4", name: "Display", description: "-", date: "06 Apr, 2021" },
        { id: "5", name: "Processor", description: "CPU & chipsets", date: "12 May, 2021" },
        { id: "6", name: "Memory", description: "RAM modules", date: "25 Jun, 2021" },
        { id: "7", name: "Storage", description: "HDD & SSD drives", date: "14 Jul, 2021" },
        { id: "8", name: "Graphics Card", description: "GPU & video cards", date: "03 Aug, 2021" },
        { id: "9", name: "Motherboard", description: "Main system board", date: "19 Sep, 2021" },
        { id: "10", name: "Power Supply", description: "SMPS units", date: "08 Oct, 2021" },
        { id: "11", name: "Cooling System", description: "Fans & liquid cooling", date: "21 Nov, 2021" },
        { id: "12", name: "Keyboard & Mouse", description: "Input devices", date: "05 Dec, 2021" },
        { id: "13", name: "Cabinet", description: "System case", date: "18 Jan, 2022" }
    ];



    document.title = "Product Group - Topcoinland";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Product group" pageTitle="Product" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <h4 className="card-title mb-0">Product group</h4>
                                </CardHeader>

                                <CardBody>
                                    <div className="listjs-table" id="customerList">
                                        <Row className="g-4 mb-3">
                                            <Col className="col-sm-auto">
                                                <div>
                                                    <Button color="success" className="add-btn me-1" onClick={() => tog_list()} id="create-btn"><i className="ri-add-line align-bottom me-1"></i> Add</Button>
                                                    <Button className="btn btn-soft-danger"
                                                    // onClick="deleteMultiple()"
                                                    ><i className="ri-delete-bin-2-line"></i></Button>
                                                </div>
                                            </Col>
                                            <Col className="col-sm">
                                                <div className="d-flex justify-content-sm-end">
                                                    <div className="search-box ms-2">
                                                        <input type="text" className="form-control search" placeholder="Search..." />
                                                        <i className="ri-search-line search-icon"></i>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <div className="table-responsive table-card mt-3 mb-1">
                                            <table className="table align-middle table-nowrap" id="customerTable">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th scope="col" style={{ width: "50px" }}>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" id="checkAll" value="option" />
                                                            </div>
                                                        </th>
                                                        <th className="sort" data-sort="id">Id</th>
                                                        <th className="sort" data-sort="customer_name">Name</th>
                                                        <th className="sort" data-sort="slug">Description</th>
                                                        <th className="sort" data-sort="status">Created At</th>
                                                        <th className="sort" data-sort="action">Operations</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list form-check-all">
                                                    {productgroup.map((item, index) => (
                                                        <tr key={index}>
                                                            <th scope="row">
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        name="checkAll"
                                                                        value={index + 1}
                                                                    />
                                                                </div>
                                                            </th>

                                                            <td className="id">
                                                                {item.id}
                                                            </td>

                                                            <td className="phone">{item.name}</td>
                                                            <td className="phone">{item.description}</td>
                                                            <td className="date">{item.date}</td>



                                                            <td>
                                                                <div className="d-flex gap-2">
                                                                    <div className="edit">
                                                                        <button
                                                                            className="btn btn-sm btn-success edit-item-btn"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#showModal"
                                                                        >
                                                                            <i className="ri-edit-line"></i>
                                                                        </button>
                                                                    </div>

                                                                    <div className="remove">
                                                                        <button
                                                                            className="btn btn-sm btn-danger remove-item-btn"
                                                                           data-bs-toggle="modal" data-bs-target="#deleteRecordModal"
                                                                        >
                                                                            <i className="ri-delete-bin-2-line"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>

                                            </table>
                                            <div className="noresult" style={{ display: "none" }}>
                                                <div className="text-center">
                                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                                                        colors="primary:#121331,secondary:#08a88a" style={{ width: "75px", height: "75px" }}>
                                                    </lord-icon>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                    <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any
                                                        orders for you search.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <div className="pagination-wrap hstack gap-2">
                                                <Link className="page-item pagination-prev disabled" to="#">
                                                    Previous
                                                </Link>
                                                <ul className="pagination listjs-pagination mb-0"></ul>
                                                <Link className="page-item pagination-next" to="#">
                                                    Next
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {/* Add Modal */}
                    <Modal isOpen={modal_list} toggle={tog_list} centered>
                        <ModalHeader toggle={tog_list}>Add Product Group</ModalHeader>
                        <ModalBody>
                            <p>Add product group form will go here.</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="light" onClick={tog_list}>
                                Cancel
                            </Button>
                            <Button color="primary" onClick={tog_list}>
                                Add
                            </Button>
                        </ModalFooter>
                    </Modal>

                </Container>
            </div>
      
        </React.Fragment>
    );
};

export default ProductGroup;
